export enum BreedsFilters {
    SHOW_IN_APP = 'showInApp'
}